import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from 'styled-components';

const CtaBanners = () => {
  return (
    <CtaBannersSection>
      <FaqBanner>
        <FaqBannerTitle>
          Want to read more about FilmChain, ways to get started with a CAMA or banking fees?
        </FaqBannerTitle>
        <FaqBannerSubtitle>
          Discover additional information on our <FaqBannerLink to="/faq">FAQ page</FaqBannerLink>
          <FaqBannerFullStop>.</FaqBannerFullStop>
        </FaqBannerSubtitle>
      </FaqBanner>
      <ContactBanner>
        <ContactBannerTitle>Any other questions or suggestions?</ContactBannerTitle>
        <ContactBannerSubtitle>
          Visit our <ContactBannerLink to="/contact-us">Contact page</ContactBannerLink>
          <ContactBannerFullStop>.</ContactBannerFullStop>
        </ContactBannerSubtitle>
      </ContactBanner>
    </CtaBannersSection>
  );
};

export default CtaBanners;

const CtaBannersSection = styled.section`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr;
  padding: 40px 0px 40px 0px;
  gap: 24px;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FaqBanner = styled.div`
  display: flex;
  height: 248px;
  padding: 40px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 16px;
  background-image: url('/img/FAQ-banner-bg.jpg');
  background-color: #110d11;
  background-position: -18.074px -109.077px;
  background-size: 143.771% 187.965%;
  background-repeat: no-repeat;
  position: relative;
  @media screen and (max-width: 768px) {
    padding: 40px;
    gap:24px;
    height: auto;
    background: url('/img/FAQ-banner-bg.jpg') lightgray -8.097px -146.022px / 143.771% 187.965%
        no-repeat,
      #110d11;
  }
`;

const ContactBanner = styled.div`
  display: flex;
  height: 248px;
  padding: 40px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 16px;
  background-image: url('/img/contact-page-footer-bg.jpg');
  background-color: #f7f6f7;
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  @media screen and (max-width: 768px) {
    gap:24px;
    height: auto;
  }
`;

const FaqBannerTitle = styled.h3`
  color: #ffffff;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
`;

const FaqBannerSubtitle = styled.p`
  color: #ffffff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

const FaqBannerLink = styled(Link)`
  color: #db6e6b;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  &:hover {
    color: #f5aba9;
  }
`;

const FaqBannerFullStop = styled.span`
  color: #db6e6b;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  &:hover {
    color: #f5aba9;
  }
`;

const ContactBannerTitle = styled.h3`
  color: #111112;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
`;

const ContactBannerSubtitle = styled.p`
  color: #68636A;
  opacity: 0.8;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

const ContactBannerLink = styled(Link)`
  opacity: 0.8;
  color: #68636A;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  &:hover {
    color: #111112;
  }
`;

const ContactBannerFullStop = styled.span`
  opacity: 0.8;
  color: #68636A;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  &:hover {
    color: #111112;
    font-weight: 600;
  }
`;
